export const INVESTOR_SESSION_KEY = 'investorSession'

export function getInvestorSessionToken(): string {
  try {
    return sessionStorage.getItem(INVESTOR_SESSION_KEY) ?? ''
  } catch {
    return ''
  }
}

export function setInvestorSessionToken(token: string | null | undefined): void {
  try {
    if (token) {
      sessionStorage.setItem(INVESTOR_SESSION_KEY, token)
    } else {
      sessionStorage.removeItem(INVESTOR_SESSION_KEY)
    }
  } catch {
    /* ignore storage errors */
  }
}
